export const getDeerFlowInstanceOrigin = (url: string) => {
  const { origin } = new URL(url);
  return origin;
};
